import { c as _c } from "react/compiler-runtime";
import { IcoFileText24 } from '@onefootprint/icons';
import { Button } from '@onefootprint/ui';
import { parseAsBoolean, useQueryState } from 'nuqs';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate/';
type AuditTrailEmptyStateProps = {
  // When set, renders the "no key events" variant with a "Show all events" CTA instead of "Add note".
  onShowAll?: () => void;
};
const AuditTrailEmptyState = t0 => {
  const $ = _c(25);
  const {
    onShowAll
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = parseAsBoolean.withDefault(false).withOptions({
      history: "push"
    });
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [, setDialogOpen] = useQueryState("show-free-form-note-dialog", t2);
  const isKeyEmpty = !!onShowAll;
  const t3 = isKeyEmpty ? "key-events-empty" : undefined;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center justify-center size-12 rounded-full bg-neutral-inverted shadow-[0_0_0_4px_rgba(0,0,0,0.04)]"><IcoFileText24 color="neutralInverted" /></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isKeyEmpty || $[4] !== t) {
    t5 = isKeyEmpty ? t(_temp) : t(_temp2);
    $[3] = isKeyEmpty;
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <p className="text-label-2">{t5}</p>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isKeyEmpty || $[9] !== t) {
    t7 = isKeyEmpty ? t(_temp3) : t(_temp4);
    $[8] = isKeyEmpty;
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <p className="text-body-3 text-tertiary">{t7}</p>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t6 || $[14] !== t8) {
    t9 = <div className="flex flex-col gap-1 max-w-xs">{t6}{t8}</div>;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isKeyEmpty || $[17] !== onShowAll || $[18] !== setDialogOpen || $[19] !== t) {
    t10 = isKeyEmpty ? <Button onClick={onShowAll} size="default" variant="secondary">{t(_temp5)}</Button> : <PermissionGate fallbackText={t(_temp6)} scopeKind="manual_review" tooltipSide="bottom"><Button onClick={() => setDialogOpen(true)} size="default" variant="secondary">{t(_temp7)}</Button></PermissionGate>;
    $[16] = isKeyEmpty;
    $[17] = onShowAll;
    $[18] = setDialogOpen;
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t3 || $[23] !== t9) {
    t11 = <div data-testid={t3} className="flex flex-col items-center gap-6 py-10 text-center">{t4}{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t3;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
export default AuditTrailEmptyState;
function _temp($) {
  return $.keyEmpty.title;
}
function _temp2($_0) {
  return $_0.emptyState.title;
}
function _temp3($_1) {
  return $_1.keyEmpty.description;
}
function _temp4($_2) {
  return $_2.emptyState.description;
}
function _temp5($_3) {
  return $_3.keyEmpty.cta;
}
function _temp6($_4) {
  return $_4.freeFormNote.addNoteButton.ctaNotAllowed;
}
function _temp7($_5) {
  return $_5.freeFormNote.addNoteButton.title;
}